import { Navigate, Outlet } from 'react-router';

import { AuthLoadingScreen } from '@/components/layout/auth-loading';
import { useAuth } from '@/hooks/use-auth';

export function OnboardingGuard() {
  const { isAuthenticated, isLoading, requiresOnboarding } = useAuth();

  if (isLoading) {
    return <AuthLoadingScreen />;
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (!requiresOnboarding) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
